import { useState } from "react"
import { bool, func } from "prop-types"

import { FormError, FormLabel, Modal } from "../../../components/common"
import { useFormErrors } from "../../../components/hooks"
import { VALIDATION_MESSAGE } from "../../../consts/validationMessage"


const ReasignarApremioModal = ({ show, onConfirm, onDismiss }) => {

    const [values, setValues] = useState({
        observacion: ''
    });

    const { errorOf, validate } = useFormErrors(getErrors);

    function getErrors() {
        const errors = {};

        if (values.observacion.trim().length === 0) errors.observacion = VALIDATION_MESSAGE.REQUIRED;

        return errors;
    }

    const handleConfirm = () => {
        if (!validate()) return;

        onConfirm(values.observacion.trim());
    };

    const footer = (
        <>
            <button className="btn btn-outline-primary" data-dismiss="modal" onClick={() => onDismiss()}>Cancelar</button>
            <button className="btn btn-primary" data-dismiss="modal"
                    onClick={handleConfirm}>Confirmar</button>
        </>
    );

    return (
        <Modal
            size="md"
            title="Confirmación"
            show={show}
            onEscape={() => onDismiss()}
            footer={footer}
            body={(
                <>
                    <p>El apremio de origen quedará sin certificados y será cancelado. ¿Confirma la reasignación?</p>
                    <div className="row form-basic">
                        <div className="mb-3 col-12">
                            <FormLabel htmlFor="observacion" required>Observación</FormLabel>
                            <textarea
                                name="observacion"
                                placeholder=""
                                className={`form-control ${errorOf('observacion') ? 'is-invalid' : ''}`}
                                value={values.observacion}
                                onChange={({ target }) => setValues(prev => ({ ...prev, observacion: target.value }))}
                                rows="4"
                                maxLength="1000"
                            />
                            <FormError message={errorOf('observacion')} />
                        </div>
                    </div>
                </>
            )}
        />
    );
};

ReasignarApremioModal.propTypes = {
    show: bool,
    onConfirm: func.isRequired,
    onDismiss: func.isRequired
};

ReasignarApremioModal.defaultProps = {
    show: true
};

export default ReasignarApremioModal;
